// extracted by mini-css-extract-plugin
module.exports = {"sectionProduct":"SectionProduct_sectionProduct_330Ki","VerticalNavBox":"SectionProduct_VerticalNavBox_3qu4I"};